import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 2 }

import moment from "moment-timezone";
import { computed } from "vue";
import { MonthPicker } from "./month-picker";
import { useDefaults } from "vuetify/lib/framework.mjs";
import { getDBFormattedDate } from "@/services/dateServices";

interface IProps {
    active?: string | string[];
    allowedDates?: string[] | Date[] | ((date: unknown) => boolean);
    // locale?: string;
    landscape?: boolean;
    color?: string;
    scrollable?: boolean;
    disabled?: boolean;

    firstDayOfWeek?: string | number;
    height?: string | number;
    hideHeader?: boolean;
    max?: Date | string;
    min?: Date | string;
    multiple?: number | boolean | (string & {}) | "range";
    position?: "fixed" | "relative" | "static" | "absolute" | "sticky";
    rounded?: string | number | boolean;
    showWeek?: boolean;
    title?: string;
    // viewMode?: "month" | "year" | "months";
    width?: string | number;
    // year?: number;
    bgColor?: string;
    border?: boolean;
    displayValue?: unknown;
    elevation?: string | number;
    header?: string;
    hideWeekdays?: boolean;
    location?: any;
    minHeight?: string | number;
    maxHeight?: string | number;
    showAdjacentMonths?: boolean;

    // Extra props for compatibility with previous use in bobbee
    range?: boolean; // Equivalent of multiple = "range"
    fullWidth?: boolean;
    returnDateStringFormat?: string; // Returns output in a given format. Only works if date input is not an object
    type?: "date" | "month";
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VDatePickerWrapper',
  props: /*@__PURE__*/_mergeModels({
    active: {},
    allowedDates: {},
    landscape: { type: Boolean, default: false },
    color: { default: "gradient" },
    scrollable: { type: Boolean, default: false },
    disabled: { type: Boolean },
    firstDayOfWeek: {},
    height: {},
    hideHeader: { type: Boolean, default: false },
    max: {},
    min: {},
    multiple: { type: [Number, Boolean, String, Object] },
    position: {},
    rounded: { type: [String, Number, Boolean] },
    showWeek: { type: Boolean },
    title: {},
    width: {},
    bgColor: {},
    border: { type: Boolean },
    displayValue: {},
    elevation: {},
    header: {},
    hideWeekdays: { type: Boolean },
    location: {},
    minHeight: {},
    maxHeight: {},
    showAdjacentMonths: { type: Boolean },
    range: { type: Boolean },
    fullWidth: { type: Boolean },
    returnDateStringFormat: {},
    type: { default: "date" }
  }, {
    "modelValue": { default: null },
    "modelModifiers": {},
    "month": {},
    "monthModifiers": {},
    "year": {},
    "yearModifiers": {},
    "viewMode": { default: "month" },
    "viewModeModifiers": {},
  }),
  emits: ["update:modelValue", "update:month", "update:year", "update:viewMode"],
  setup(__props: any) {

/**
 * Vuetify 3 VDatePicker Wrapper. Allows to use v-model with string or Date
 */
const props_ = __props;

const props = useDefaults(props_);

const model = _useModel<string | Date | null | string[] | Date[]>(__props, "modelValue");
const monthModel = _useModel<string | number>(__props, "month");
const yearModel = _useModel<number>(__props, "year");
const viewMode = _useModel<"month" | "year" | "months">(__props, "viewMode");

const dateValue = computed({
    get: () => {
        if (!Array.isArray(model.value)) {
            return model.value ? moment(model.value).toDate() : model.value;
        } else {
            return model.value.map((date) => moment(date).toDate());
        }
    },
    set: (value) => {
        if (Array.isArray(value)) {
            const valueType = typeof model.value[0];
            model.value = [...new Set(value.map((date) => dateToType(date, valueType)))];
        } else {
            const valueType = typeof model.value;
            model.value = dateToType(value, valueType);
        }
    },
});

const dateToType = (value, valueType) => {
    // debugger;
    if (valueType === "string") {
        const format = props.returnDateStringFormat || "YYYY-MM-DD";
        return getDBFormattedDate(value, format);
    } else if (valueType === "object" && value instanceof Date) {
        return moment(getDBFormattedDate(value)).toDate();
    } else {
        if (props.returnDateStringFormat) {
            return getDBFormattedDate(value, props.returnDateStringFormat);
        }
        return value;
    }
};

const multipleValue = computed(() => {
    if (props.range) {
        return "range";
    }
    return props.multiple;
});

const widthValue = computed(() => {
    if (props.fullWidth) {
        return "100%";
    }
    return props.width;
});

return (_ctx: any,_cache: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_ctx.type === 'date')
    ? (_openBlock(), _createBlock(_component_v_date_picker, _mergeProps({ key: 0 }, _unref(props), {
        modelValue: dateValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateValue).value = $event)),
        month: monthModel.value,
        "onUpdate:month": _cache[1] || (_cache[1] = ($event: any) => ((monthModel).value = $event)),
        year: yearModel.value,
        "onUpdate:year": _cache[2] || (_cache[2] = ($event: any) => ((yearModel).value = $event)),
        "view-mode": viewMode.value,
        "onUpdate:viewMode": _cache[3] || (_cache[3] = ($event: any) => ((viewMode).value = $event)),
        multiple: multipleValue.value,
        width: widthValue.value
      }), null, 16, ["modelValue", "month", "year", "view-mode", "multiple", "width"]))
    : (_ctx.type === 'month')
      ? (_openBlock(), _createBlock(_unref(MonthPicker), _mergeProps({ key: 1 }, { ..._unref(props) }, {
          modelValue: model.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((model).value = $event))
        }), null, 16, ["modelValue"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, "Unsupported type"))
}
}

})